import { AlertMessage, Button, CoreLoader, Input, Label } from "common/components";
import { useNavigate } from "react-router-dom";
import apiManager from "networking/baseAPIManager";
import { useState } from "react";

export default function EmployeeDetail() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showMSG, setShowMSG] = useState(false);
  const [msgType, setmsgType] = useState("info");

  const handleSubmit = (e) => {
    e.preventDefault();

    const deatials = `?company_email=${email}`;
    setLoading(true);
    apiManager
      .createdocument(deatials)
      .then((res) => {
        setLoading(false);
        setmsgType("success");
        setShowMSG(res?.data?.message || "details updated successfully");
        navigate(`/hrtools/generate-documents/employee-details`, { state: res.data });
      })
      .catch((error) => {
        setmsgType("error");
        setShowMSG(error?.response?.data?.message || "failed to update");
        setLoading(false);
        console.log(error?.response?.data?.message, "message");
      });
  };

  return (
    <div>
      <AlertMessage show={showMSG} setShow={setShowMSG} type={msgType} />
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="row p-4">
            <div className="col-md-12 d-flex align-items-center">
              <Label label="Employee ID/Name" parentclasses="col-md-4 " />
              <Input
                parentclasses="col-md-8"
                name="email_id"
                type="email"
                placeholder="Employee email/Name"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-10 d-flex justify-content-end">
              <Button label="Submit" type="submit" />
            </div>
          </div>
        </form>
        <CoreLoader show={loading} disableLines />
      </div>
    </div>
  );
}
